import { Dashboard, Pages } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";
import { Home } from "./Home";
import { currentFeatures } from "../../configs/Settings";
import { useSessionContext } from "@/contexts/SessionContext";
import { useOrganizationContext } from "@/contexts/OrganizationContext";
import { isEcommerceOrganization } from "@/pages/ecommerce/helpers/isEcommerceOrganization";
import FluxVetDashboard from "@/fluxvet/pages/dashboard/FluxVetDashboard";

/**
 * Componente da página Home declarado fora do hook para ter referência estável.
 * Com uma arrow function inline em `component`, cada re-render do
 * LegacyDynamicPageRouter criava um novo tipo de componente e o React remontava
 * o dashboard inteiro. No paciente isso virava loop: a agenda chama
 * `setIdsOrganizations` (LocationContext) → o router re-renderiza → a Home
 * remonta → a agenda busca de novo → `setIdsOrganizations` alterna "" / ids.
 */
function HomePage() {
  const { access } = useSessionContext();

  return !currentFeatures.defaultApp && access.type === "patient" ? (
    <FluxVetDashboard />
  ) : (
    <Home />
  );
}

export function useHome() {
  const { access } = useSessionContext();
  const { organization } = useOrganizationContext();
  const isEcommerceProfessional =
    access.type === "professional" && isEcommerceOrganization(organization);

  const configs: IFeatures = {
    initial: !isEcommerceProfessional,
    active: currentFeatures.home && !isEcommerceProfessional,
    path: "/home",
    text: currentFeatures.defaultApp ? "Painel de controle" : "Dashboard",
    icon: currentFeatures.defaultApp ? Pages : Dashboard,

    sideMenu: !isEcommerceProfessional,
    sideMenuIndex: 0,

    component: HomePage,
  };

  return configs;
}
